import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { Link, Navigate } from "react-router-dom";
import { withRouter } from "../utils/withRouter";
import { UserOutlined } from "@ant-design/icons";

import { Layout, Menu, Avatar, Dropdown } from "antd";

import { ReactComponent as Logo } from "@/assets/logo/logo_full_white.svg";

import Router from "./Router";

import Acquisitions from "./navs/Acquisitions";
import Settings from "./navs/Settings";
import Management from "./navs/Management";
import CommoditySpotPrices from "../common/CommoditySpotPrices";
import Activities from "../activities/ActivitiesWidget";

import { hasPermission, PERMISSIONS } from "../common/permissions";
import { getNavSelectedKeys } from "./navigation";

import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,
  SettingOutlined,
  SolutionOutlined,
} from "@ant-design/icons";

import {
  getStoredPageSettings,
  updateStoredPageSettings,
} from "../utils/settings";
import { lazyWithReload } from "../utils/lazyWithReload";

import styles from "./MainLayout.module.scss";

const Communications = lazyWithReload(
  () => import("../communications/Communications")
);

const { Header, Sider, Content } = Layout;

const iconSize = 34;

const SIDER_STORAGE_KEY = "nav.sider";

const getMenuItems = (props) => {
  const items = [];

  items.push({
    key: "profile",
    label: <Link to={`/settings/users/${props.currentUser?.id}`}>Profile</Link>,
  });

  items.push({
    key: "signOut",
    label: "Sign Out",
    onClick: () => props.logoutUser(),
    className: styles.signOut,
  });

  return items;
};

class MainLayout extends Component {
  state = {
    collapsed: Boolean(getStoredPageSettings(SIDER_STORAGE_KEY).collapsed),
    navSelectedKeys: getNavSelectedKeys(this.props.location.pathname),
  };

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
    updateStoredPageSettings(SIDER_STORAGE_KEY, { collapsed });
  };

  componentDidUpdate() {
    const navSelectedKeys = getNavSelectedKeys(this.props.location.pathname);
    if (
      JSON.stringify(this.state.navSelectedKeys) !==
      JSON.stringify(navSelectedKeys)
    ) {
      this.setState({
        navSelectedKeys: navSelectedKeys,
      });
    }
  }

  render() {
    const { currentUser } = this.props;
    const canViewManagement = hasPermission(
      currentUser,
      PERMISSIONS.MANAGEMENT_GENERAL_READ
    );
    const canViewSettings = Boolean(currentUser && currentUser.super_admin);

    const redirectURL = "/units?limit=50&page=1";

    if (this.props.isAuthenticated === false) {
      return (
        <Navigate
          to={{
            pathname: "/login",
            state: { referrer: this.props.currentUrl },
          }}
        />
      );
    } else if (this.props.location.pathname === "/") {
      return <Navigate to={redirectURL} />;
    } else {
      return (
        <div>
          <Layout className={styles.main}>
            <Header className={styles.header}>
              <div className={styles.leftHeader}>
                <button
                  type="button"
                  className={styles.navToggle}
                  onClick={() => this.onCollapse(!this.state.collapsed)}
                  aria-label={
                    this.state.collapsed
                      ? "Expand navigation"
                      : "Collapse navigation"
                  }
                >
                  {this.state.collapsed ? (
                    <MenuUnfoldOutlined />
                  ) : (
                    <MenuFoldOutlined />
                  )}
                </button>
                <Link to={redirectURL} className={styles.logoLink}>
                  <Logo className={styles.headerLogo} />
                </Link>
                <CommoditySpotPrices />
              </div>
              <div className={styles.rightHeader}>
                {process.env.NODE_ENV === "development" && (
                  <div className={styles.developmentBadge}>development</div>
                )}
                <div className={styles.iconDiv}>
                  <Suspense fallback={null}>
                    <Communications />
                  </Suspense>
                </div>
                <div className={styles.iconDiv}>
                  <Activities />
                </div>
                <div className={styles.iconDivider} />
                <div className={styles.iconDiv}>
                  <Link to={redirectURL}>
                    <Avatar
                      className={styles.icon}
                      shape="square"
                      size={iconSize}
                      icon={<SolutionOutlined />}
                    />
                  </Link>
                </div>
                {canViewManagement && (
                  <div className={styles.iconDiv}>
                    <Link to="/management/deals?limit=50&page=1">
                      <Avatar
                        className={styles.icon}
                        shape="square"
                        size={iconSize}
                        icon={<PieChartOutlined />}
                      />
                    </Link>
                  </div>
                )}
                {canViewSettings && (
                  <div className={styles.iconDiv}>
                    <Link to={`/settings/jobs`}>
                      <Avatar
                        className={styles.icon}
                        shape="square"
                        size={iconSize}
                        icon={<SettingOutlined />}
                      />
                    </Link>
                  </div>
                )}
                <div className={styles.iconDiv}>
                  <Dropdown
                    menu={{
                      items: getMenuItems(this.props),
                      className: styles.avatarDropDownMenu,
                    }}
                    placement="bottomLeft"
                    trigger={["click"]}
                  >
                    <Avatar
                      className={styles.icon}
                      shape="square"
                      size={iconSize}
                      icon={<UserOutlined />}
                    />
                  </Dropdown>
                </div>
              </div>
            </Header>
            <Layout>
              <Sider
                className={`${styles.siderNav} ${
                  this.state.collapsed ? styles.siderNavCollapsed : ""
                }`}
                theme="light"
                width={140}
              >
                {this.props.location.pathname.includes("settings") ? (
                  <Settings navSelectedKeys={this.state.navSelectedKeys} />
                ) : this.props.location.pathname.includes("management") ? (
                  <Management navSelectedKeys={this.state.navSelectedKeys} />
                ) : (
                  <Acquisitions navSelectedKeys={this.state.navSelectedKeys} />
                )}
              </Sider>
              <Content className={styles.mainContent}>
                <Router {...this.props} />
              </Content>
            </Layout>
          </Layout>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  currentUser: get(state, "user.data", null),
});

export default connect(mapStateToProps)(withRouter(MainLayout));
